import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import config from 'config';
import Section from 'components/Section';
import { Divider, Paper } from '@material-ui/core';
import './Instructions.css';

const videos = [
  {
    title: 'Perustoiminnot',
    url: 'https://www.youtube.com/embed/Bx7ZP61kGiQ?enablejsapi=1',
  },
  {
    title: 'Esirajaus, proksimiteettihaku ja visualisointipuolen suodattimet',
    url: 'https://www.youtube.com/embed/wmKf8W-SwDA?enablejsapi=1',
  },
  {
    title: 'Aikajana',
    url: 'https://www.youtube.com/embed/76YpPtn4rWY?enablejsapi=1',
  },
  {
    title: 'Metatietojen lataaminen',
    url: 'https://www.youtube.com/embed/RChjhxnY9kg?enablejsapi=1',
  },
];

const Instructions = () => {
  // scroll to top when entering page view
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <>
      <Helmet>
        <title>Ohjeet | {config.site.name}</title>
      </Helmet>
      <Section className="section--page">
        <Paper elevation={2}>
          <div className="page-wrapper">
            <h1 className="page-title">
              Ohjeet Lakitutkan käyttöön
            </h1>
            <Divider />
            <p>
              <a
                className="big-link"
                href="https://lakitutka.fi/media/Lakitutka_ohjeet.pdf"
              >
                Lataa tekstimuotoiset ohjeet (pdf)
              </a>
            </p>
            <p>
              <strong>
                Huom! Videoissa esiintyvä
                ’Lausuntokierrokset’ välilehti vastaa
                sisällöltään täysin nykyistä
                ’Valmisteluasiakirjat’ välilehteä.
                Välilehden nimi on muutettu, jotta se
                kuvaisi sisältöä paremmin.”
              </strong>
            </p>
            {videos.map((video) => (
              <>
                <h2 className="page-subtitle">
                  {video.title}
                </h2>
                <iframe
                  className="embed-video"
                  title="video"
                  width="700"
                  height="394"
                  src={video.url}
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </>
            ))}
          </div>
        </Paper>
      </Section>
    </>
  );
};

export default Instructions;
